"use strict";
// @ts-ignore
require("bootstrap/js/dist/collapse");
